<template>
  <div class="list-body">
    <el-table border :data="orderList" style="width: 100%" class="list-table" tooltip-effect="dark">
      <el-table-column property="policyNo" min-width="220" label="原保单号/续保单号">
        <template slot-scope="{ row }">
          <tooltip :txt-info="row.policyNo | filterEmpty"></tooltip>
          <tooltip :txt-info="row.newPolicyNo | filterEmpty"></tooltip>
        </template>
      </el-table-column>
      <el-table-column min-width="160" label="出单账户" key="mechanName" v-if="employee">
        <template slot-scope="{ row }">
          {{ row.mechanName | filterEmpty }}
        </template>
      </el-table-column>
      <el-table-column min-width="200" label="产品名称">
        <template slot-scope="{ row }">
          {{ row.productName | filterEmpty }}
        </template>
      </el-table-column>
      <el-table-column min-width="140" label="投/被保人">
        <template slot-scope="{ row }">
          <div>{{ row.policyerName }}<span v-if="row.policyerName && row.insuranceName">/</span>{{ row.insuranceName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="到期日" min-width="130">
        <template slot-scope="{ row }">
          <div>{{ row.endTime | filterTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="保费/服务费 (元)" min-width="120" key="incomes" v-if="checkAuth('orderCommission')">
        <template slot="header" slot-scope="scope">
          <span>保费/服务费 (元) </span>
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="max-width:300px;text-align: left;">
              待续保、续保失败或不可续保的保单，此处为原保单保费和服务费；续保成功的保单，此处为新保单保费和服务费
            </div>
            <span class="icon-wenhao1"></span>
          </el-tooltip>
        </template>
        <template slot-scope="{ row }">
          <div v-if="row.newFee">{{ row.newFee }}<span v-if="row.newFee && row.incomes">/</span>{{ row.incomes }}</div>
          <div v-else>{{ row.fee }}<span v-if="row.fee && row.incomes">/</span>{{ row.incomes }}</div>
        </template>
      </el-table-column>
      <el-table-column label="保费 (元) " min-width="120" key="fee" v-else>
        <template slot="header" slot-scope="scope">
          保费 (元)
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="max-width:300px;text-align: left;">
              待续保、续保失败或不可续保的保单，此处为原保单保费；续保成功的保单，此处为新保单保费
            </div>
            <span class="icon-wenhao1"></span>
          </el-tooltip>
        </template>
        <template slot-scope="{ row }">
          <div v-if="row.newFee">{{ row.newFee }}</div>
          <div v-else>{{ row.fee }}</div>
        </template>
      </el-table-column>
      <el-table-column label="保单状态/续保状态" min-width="160">
        <template slot-scope="{ row }">
          <div style="white-space: nowrap;">
            {{ all.POLICY_STATUS[row.policyStatus] }}<span v-if="row.policyStatus && row.renewalStatus">/</span>{{ row | filterStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <div class="card-btn" slot-scope="{ row }">
          <el-button class="xq-btn" type="primary" @click="goDetail(row.policyNo, row.newPolicyNo, '1', row.mechanName, row.mechanLevel)" plain>详情</el-button>
          <el-popover popper-class="gd-popper" placement="right-start" width="100" trigger="click">
            <ul class="more">
              <template v-if="row.renewalStatus == '2' || row.renewalStatus >= 6">
                <li @click="renewalLink(row.policyNo)" class="copy">复制续保链接</li>
              </template>
              <li @click="$refs.orderFollowRef.open(row)">跟进备注</li>
            </ul>
            <el-button slot="reference" type="text">更多<i class="el-icon-arrow-down"></i></el-button>
          </el-popover>
        </div>
      </el-table-column>
      <emptyBox slot="empty"></emptyBox>
    </el-table>
    <!-- 跟进备注 -->
    <orderFollow ref="orderFollowRef" formType="short" @reload="$emit('getRenewalPolicys')"></orderFollow>
  </div>
</template>

<script>
import orderFollow from './orderFollow';
import tooltip from '@/components/tooltip';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    orderFollow,
    tooltip
  },
  props: {
    orderList: Array
  },
  data: () => ({
    all: {},
    employee: true
  }),
  created() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getUserInfo();
  },
  mounted() {
    // this.resize()
  },
  methods: {
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      // 1一级团队 2二级团队 3员工
      if (data.level != 3 && data.level != 2) {
        this.userFlag = true;
      }
      if (data.level == 3) {
        this.employee = false;
      }
    },
    goDetail(policyNo, newPolicyNo, renewalType, mechanName, mechanLevel) {
      this.$router.push({
        path: '/order_xfd_detail',
        query: {
          policyNo: policyNo,
          newPolicyNo: newPolicyNo,
          renewalType: renewalType,
          mechanName: mechanName,
          mechanLevel: mechanLevel
        }
      });
    },
    // 续保链接
    renewalLink(policyNo) {
      this.$http({
        url: '/master/policy/getRenewalUrl',
        type: 'put',
        params: {
          policyNo: policyNo
        }
      })
        .then(res => {
          if (res.httpCode == 200) {
            let url = res.data;
            const cInput = document.createElement('input');
            cInput.value = url;
            document.body.appendChild(cInput);
            cInput.select(); // 选取文本域内容;
            // 执行浏览器复制命令
            // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
            // Input要在正常的编辑状态下原生复制方法才会生效
            document.execCommand('Copy');
            this.$message({
              message: '复制成功',
              type: 'success'
            });
            /// 复制成功后再将构造的标签 移除
            cInput.remove();
          }
        })
        .catch(e => {});
    }
  },
  filters: {
    filterNull(val) {
      if (val == '' || val == null) {
        return '-';
      } else {
        return val;
      }
    },
    filterTime(time) {
      if (time != '' && time !== null) {
        time = time.split(' ')[0].replace(/-/g, '/');
        return time;
      }
      return '/';
    },
    filterStatus(row) {
      const val = row.renewalStatus;
      if(row.isRenewal == 0 || row.productIsRenewal == 0) {
        return '不可续保';
      } else if (val == '2') {
        return '待续保';
      } else if (val == '5') {
        return '续保成功';
      } else if (Number(val) >= 6) {
        return '续保失败';
      } else {
        return '-';
      }
    },
    filterPolicyStatus(val) {
      if (val == '1' || val == '4' || val == '7' || val == '8') {
        return '未支付';
      } else if (val == '2' || val == '9') {
        return '已支付';
      } else if (val == '3') {
        return '已退款';
      } else if (val == '5' || val == '6') {
        return '已关闭';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './order_xbd_card';
</style>
